import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import Notification from "../notification";
import { notificationCustomStyle } from "../notifications/notification_styles";
import PageFooter from "../page_footer";
import PageHeader from "../page_header";
import PatientMenu from "../patient_menu";
import PatientsListNew from "./patients_list_new";
import Tour from "./tour";

export default function PatientsListPageBody(props: RouteComponentProps) {
  return (
    <div>
      <Tour />
      <PageHeader />
      <div className="container">
        <div className="page-container">
          <PatientMenu />
          <Notification style={notificationCustomStyle} />
          <PatientsListNew {...props} />
        </div>
        <PageFooter />
      </div>
    </div>
  );
}
